import request from '@/utils/request'
import qs from 'qs'

export function addFirstRouter(data: { name: string }) {
  return request({
    url: '/author/firstTier',
    method: 'post',
    data: qs.stringify(data)
  })
}

export function addSecondRouter(data: { firstId: string, name: string }) {
  return request({
    url: '/author/secondTier',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 添加接口权限管理
export interface IAddApi {
  firstId: string,
  secondId: string,
  url: string,
  name: string,
  method: 'POST' | 'GET',
  isAny: 0 | 1
}
export function addApiRouter(data: IAddApi) {
  return request({
    url: '/author/router',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除权限接口
export function deleteApiRouter(data: { id: string }) {
  return request({
    url: '/author/delRouter',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除一级路由
export function deleteFirstRouter(data: { id: string }) {
  return request({
    url: '/author/delFirstTier',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 删除二级路由
export function deleteSecondRouter(data: { id: string }) {
  return request({
    url: '/author/delSecondTier',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改一级路由
export function updateFirstRouter(data: { id: string, name: string }) {
  return request({
    url: '/author/updateFirstTier',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改二级路由
export function updateSecondRouter(data: { id: string, name: string }) {
  return request({
    url: '/author/updateSecondTier',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 修改权限路由
export function updateApiRouter(data: { id: string, name: string, path: string, method: string }) {
  return request({
    url: '/author/updateRouter',
    method: 'post',
    data: qs.stringify(data)
  })
}
// 获取权限路由信息
export function getApiRouter(data: { id: string }) {
  return request({
    url: '/author/getRouterInfo',
    method: 'get',
    params: data
  })
}
